/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { VisionApplication } from '../application';
import { VisionWindow } from './window';

export class VisionWindowManager {
    app!: VisionApplication;
    windows!: Map<string, VisionWindow>;
    win!: dhtmlXWindows;

    constructor() {
        this.app = VisionApplication.getInstance();
        this.windows = new Map<string, VisionWindow>();
        this.win = this.app.layout.layout.dhxWins;

        //var menu = this.app.layout.avlTab.menuBar;
        //var menu = this.app.menuManager.menuBar;

        //menu.addNewChild("windows", 0, "edit_device_window", "Devices", false, "", "");
        //menu.addNewChild("windows", 1, "edit_asset_folder_window", "Asset Folders", false, "", "");
        //menu.addNewChild("windows", 2, "report_winter_material_usage", "Material Usage", false, "", "");
        //menu.addNewChild("windows", 3, "edit_organization_window", "Organization Configuration", false, "", "");
        //menu.addNewChild("windows", 4, "edit_asset_window", "Edit Asset", false, "", "");
        //menu.addNewChild("windows", 5, "edit_geofence_window", "Edit Geofence", false, "", "");
    }

    createWindow(id: string, x: number, y: number, width: number, height: number): dhtmlXWindowsCell {
        const created = this.win.createWindow(id, x, y, width, height);
        return created;
    }
}
